<template>
    <div class="form-component">
        <v-form v-if="!showLineForm" :lazy-validation="true" ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="goTo('/Supplierslist')">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                Template de Facturas
            </h3>
            <v-container fluid class="pa-0">
                <!-- main form -->
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-text-field
                            class="lance"
                            label="Vendor Number"
                            v-model="form.supplierCode"
                            :disabled="true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-text-field
                            class="lance"
                            label="RFC / Tax ID"
                            v-model="form.supplierId"
                            :disabled="true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            class="lance"
                            label="Razón Social"
                            v-model="form.supplierBusinessName"
                            :disabled="true">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-text-field
                            class="lance"
                            label="Número de hojas a ignorar al inicio"
                            type="number"
                            v-model="form.numberOfPagesToIgnoreAtStart"
                            :rules="[v => !v || v>=0 || 'Este campo no puede ser negativo']"
                            :disabled="view"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-text-field
                            class="lance"
                            label="Número de hojas a ignorar al final"
                            v-model="form.numberOfPagesToIgnoreAtEnd"
                            :rules="[v => !v || v>=0 || 'Este campo no puede ser negativo']"
                            type="number"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs12 md3 grow>
                        <v-select
                            solo
                            v-model="form.fileType"
                            :items="fileTypes"
                            label="Tipo de archivo"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-select>
                    </v-flex>
                    <v-flex xs12 md9 grow>
                        <v-text-field
                            v-if="!view"
                            class="lance no-right-padding"
                            label="Ruta de archivo template"
                            v-model="form.templateFileRoute"
                            readonly
                            :disabled="view || !this.form.fileType">
                            <template slot="append">
                                <div class="fileSelectButton" @click="form.fileType ? openFileSelect(): null">
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                    <span class="dot"></span>
                                </div>
                            </template>
                        </v-text-field>
                    </v-flex>
                    
                    <v-flex xs12 md6>
                        <v-select class="lance"
                            v-model="form.localeLanguage"
                            label="Lenguaje de la factura"
                            :items="localeLanguageList"
                            item-text="text"
                            item-value="value"
                            :disabled="view"
                        ></v-select>
                    </v-flex>
                </v-layout>

                <!-- invoice fields table -->
                <v-layout row wrap>
                    <v-flex xs12>
                        <h3>
                            Listado de Campos
                            <v-btn v-if="!view" 
                                fab color="primary" 
                                @click="showLineForm = true; selectedFieldIdx=null;" 
                                style="width:50px; height:50px;" 
                                :disabled="!form.fileType">
                                <v-icon large>add</v-icon>
                            </v-btn>
                        </h3>
                    </v-flex>
                    <v-flex xs12>
                        <div class="table-catalog table-catalog-border-first elevation-5">
                            <table class="v-datatable v-table theme--light">
                                <thead>
                                    <tr class="" style="height: auto;">
                                        <th class="text-xs-left pt-0 pb-3">Campo</th>
                                        <th class="text-xs-left pt-0 pb-3">Referencia</th>
                                        <th class="text-xs-left pt-0 pb-3">Posición de Referencia</th>
                                        <th class="text-xs-left pt-0 pb-3">Vértices / Celdas</th>
                                        <th class="text-xs-left pt-0 pb-3"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(field, idx) in form.invoiceTemplateLines" :key="idx">
                                        <td class="py-2" style="font-family: 'Montserrat', sans-serif;" v-text="field.field"></td>
                                        <td class="">{{ field.reference }}</td>
                                        <td class="">{{ field.referencePosition }}</td>
                                        <td class="">{{ cellField(field) }}</td>
                                        <td style="min-width: 128px;">
                                            <v-btn fab small color="primary" 
                                                v-if="!view"
                                                @click.stop="editField(idx)">
                                                <img src="@/assets/icon-editar.svg" alt="">
                                            </v-btn>
                                            <v-btn fab small color="error" 
                                                v-if="!view"
                                                @click.stop="confirmDeleteField(idx)">
                                                <img src="@/assets/icon-eliminar.svg" alt="">
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-flex>
                </v-layout>

                <!-- Save button -->
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view" solo color="submitBtn" @click="save()" :disabled="!valid">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>

        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">Confirmación</v-card-title>
                <v-card-text>¿Está seguro de querer borrar este registro?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = null;">Cancelar</v-btn>
                    <v-btn color="primary" flat @click="deleteDialog=false; deleteField(itemToDelete)">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="fileTypeDialog" max-width="450">
            <v-card>
                <v-card-title class="headline">Confirmación</v-card-title>
                <v-card-text>
                    ¿Esta seguro que quiere cambiar el tipo de archivo? <br>
                    Si se cambia el tipo de archivo todos los campos se eliminarán
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="fileTypeDialog=false; form.fileType = oldFileType;">Cancelar</v-btn>
                    <v-btn color="primary" flat @click="fileTypeDialog=false; deleteAllFields()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <InvoiceTemplateLineForm
            v-if="showLineForm"
            :initialField="form.invoiceTemplateLines[selectedFieldIdx]"
            :usedFields="form.invoiceTemplateLines.map(x => x.field)"
            :imageSources="imageSources"
            :workbook="workbook"
            :fieldOptions="fieldOptions"
            :tableFieldOptions="tableFieldOptions"
            :isPosition="form.fileType=='PDF' || form.fileType=='Imagen'"
            @add="addFieldHandler"
            @edit="editFieldHandler"
            @close="showLineForm = false; selectedField=null;"
        ></InvoiceTemplateLineForm>
    </div>
</template>

<script>
import XLSX from 'xlsx';
import { events } from "../main";
import InvoiceTemplateLineForm from "./invoiceTemplateLineForm";

export default {
    data() {
        return {
            valid: null,
            view: false,
            form: {
                numberOfPagesToIgnoreAtStart: 0,
                numberOfPagesToIgnoreAtEnd: 0,
                templateFileRoute: null,
                invoiceTemplateLines: [],
            },
            selectedFieldIdx: null,
            showLineForm: false,
            localeLanguageList: [
                { text: "Español (España)", value: "es-ES" },
                { text: "Español (México)", value: "es-MX" },
                { text: "Inglés", value: "en" },
            ],
            fileTypes: [ 
                { text: "Archivo tipo PDF", value: "PDF" },
                { text: "Archivo tipo XLS", value: "XLS" },
                { text: "Archivo tipo Imagen", value: "Imagen" },
            ],
            imageSources: [],
            workbook: null,
            fieldOptions: [],
            tableFieldOptions: [],
            deleteDialog: false,
            itemToDelete: null,
            fileTypeDialog: false,
            oldFileType: null,
        };
    },
    methods: {
        snack(msg, options=null) {
            events.$emit('snackbar', msg, options);  
        },
        goTo(url) {
            this.$router.push(url);
        },
        cellField(field) {
            if (!this.form.fileType) {
                return "";
            } else if (this.form.fileType == "PDF" || this.form.fileType == "Imagen") {
                return `(${field.posTopX}, ${field.posTopY}) a (${field.posBottomX}, ${field.posBottomY})`;
            } else if (this.form.fileType == "CSV" || this.form.fileType == "XLS") {
                if (field.isCellRange)
                    return `Rango ${field.rangeStart} a ${field.rangeEnd}`;
                else 
                    return `Celda ${field.cell}`;
            }
        },
        openFileSelect() {
            // reset file variables
            this.imageSources = [];
            this.workbook = null;
            this.$set(this.form, "templateFileRoute", "");
            
            // create file input to trigger click event
            let domInput = document.createElement("input");
            domInput.setAttribute("type", "file");
            domInput.click();
            domInput.onchange = (event) => {
                let file = domInput.files[0];

                if (this.form.fileType == "Imagen" && !file.type.startsWith("image")) {
                    this.snack("Archivo inválido, se esperaba una imagen");
                    return;
                } else if (this.form.fileType == "PDF" && !file.type.endsWith("pdf")) {
                    this.snack("Archivo inválido, se esperaba un PDF");
                    return;
                } else if (this.form.fileType == "CSV" && !file.name.endsWith(".csv")) {
                    this.snack("Archivo inválido, se esperaba un CSV");
                    return;
                } else if (this.form.fileType == "XLS" && (!file.type.endsWith("vnd.ms-excel") && file.type.indexOf("spreadsheet")==-1 || file.name.endsWith("csv"))) {
                    this.snack("Archivo inválido, se esperaba un Excel");
                    return;
                }
                // using set so vue can react to the change
                this.$set(this.form, "templateFileRoute", file.name);
                
                let reader = new FileReader();
                if (file.type == "application/pdf") {
                    reader.onload = () => {
                        this.imageSources = ["loading"];
                        this.$http.post("util/pdf2image", { data: reader.result.split(",")[1] }).then( result => {
                            this.imageSources = result.body;
                        });
                    };
                    reader.readAsDataURL(file);
                } else if (file.type.indexOf("excel")!=-1 || file.type.indexOf("csv")!=-1 || file.type.indexOf("spreadsheet")!=-1) {
                    reader.onload = () => {
                        this.workbook = XLSX.read(new Uint8Array(reader.result), { type: "array", cellDates: true });
                    };
                    reader.readAsArrayBuffer(file);
                } else {
                    reader.onload = () => {
                        this.imageSources = [reader.result];
                    };
                    reader.onerror = error => console.error(error);
                    reader.readAsDataURL(file);
                }
            };
        },
        // field form event handlers
        addFieldHandler(obj) {
            if (this.form.invoiceTemplateLines)
                this.form.invoiceTemplateLines.push(obj);
        },
        editFieldHandler(obj) {
            if (this.form.invoiceTemplateLines && this.form.invoiceTemplateLines[this.selectedFieldIdx]) {
                this.form.invoiceTemplateLines[this.selectedFieldIdx] = obj;
            }
        },
        // field table buttons
        editField(idx) {
            this.showLineForm = true;
            this.selectedFieldIdx = idx;
        },
        confirmDeleteField(idx) {
            this.itemToDelete = idx;
            this.deleteDialog = true;
        },
        deleteField(idx) {
            if (idx==null) return;
            this.form.invoiceTemplateLines.splice(idx, 1);
            this.$forceUpdate();
            this.itemToDelete = null;
        },
        deleteAllFields() {
            this.oldFileType = null;
            this.form.invoiceTemplateLines = [];
            this.$forceUpdate();
        },
        // 
        save() {
            if (this.$refs.form.validate()) {
                this.$http.put("InvoiceTemplate", this.form)
                .then(result => {
                    this.goTo("/Supplierslist");
                }).catch(error => {
                    this.snack(error.msg || "Hubo un error al obtener el template");
                });
            }
        },
    },
    mounted() {
        let supplierCode = this.$route.params.id;
        if (this.$route.name.includes('Detail') ) {
            this.view = true;
        }
        this.$http.get(`InvoiceTemplate/form/${supplierCode}`)
        .then( result => {
            this.form = result.body.invoiceTemplate;
            this.fieldOptions = result.body.fieldOptions;
            this.tableFieldOptions = result.body.tableFieldOptions;
            this.hasPagesToIgnoreAtStart = !!this.form.numberOfPagesToIgnoreAtStart;
            if (!this.form.invoiceTemplateLines)
                this.form.invoiceTemplateLines = [];
        }).catch( error => {
            this.snack(error.msg || "Hubo un error al obtener el template");
        });
    },
    watch: {
        "form.fileType": function(newVal, oldVal) {
            if (oldVal && !this.oldFileType && this.form.invoiceTemplateLines.length>0) {
                this.fileTypeDialog = true;
                this.oldFileType = oldVal;
            } else {
                this.oldFileType = null;
            }
        },
    },
    components: {
        InvoiceTemplateLineForm,
    },
}
</script>

<style scoped>
    div.fileSelectButton {
        width: 100%;
        height: 100%;
        display: inline-flex;
        cursor: pointer;
    }
    span.dot {
        height: 12px;
        width: 12px;
        border-radius: 50%;
        background: white;
        align-self: center;
        margin-right: 6px;
    }
    .v-input--is-disabled span.dot {
        background: #aaa;
    }
    span.dot:first-child {
        margin-left: 18px;
    }
    span.dot:last-child {
        margin-right: 22px;
    }
    .table-catalog {
        padding-left: 10px;
        padding-right: 10px;
    }
    .table-catalog th {
        font-size: 14px !important;
    }
    .table-catalog th:last-child,
    .table-catalog td:last-child {
        border: none !important;
    }
    .table-catalog table.v-table thead th,
    .table-catalog table.v-table tbody td {
        padding-left: 12px !important;
    }
    .grow {
        max-width: none;
    }
    table.v-table thead th {
        white-space: pre-line;
    }
</style>
